
import { Vue, Options } from "vue-class-component";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import router from "../../router";
import { CargoController } from "../../controllers/CargoController";
import { NGenController } from "../../controllers/NGenController";
import { CARGO } from "@/app/infrastructures/misc/RolePermission";
import { CargoData } from "@/domain/entities/Cargo";
import { capitalize } from "@vue/shared";
import { QueryParamsEntities2 } from "@/domain/entities/MainApp";
import { ReadyToCargoController } from "../../controllers/ReadyToCargoController";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import CargoFilterSection from "./component/cargo-filter-section.vue";

@Options({
  components: { CargoFilterSection },
  computed: {
    ableToViewDetail() {
      return FlagsPermissionCargo.permission_cargo_detail_view.isEnabled();
    }
  }
})
export default class TabBookingCanceled extends Vue {
  created() {
    CargoController.setCargoStatus("cancel,failed");
    CargoController.setStartDate(
      new Date(new Date(new Date().setDate(new Date().getDate() - 1))) as Date | null
    );
    CargoController.setEndDate(new Date() as Date | null);
  }

  mounted() {
    CargoController.setFirstPage();
    this.fetchLastIdRetryCargo();
    this.startInterval();
    this.$posthog.startSessionRecording();
  }
  unmounted() {
    CargoController.onReset();
    this.stopInterval();
  }

  fetchInterval = null as any;
  startInterval() {
    this.fetchInterval = setInterval(() => {
      this.fetchLastIdRetryCargo();
    }, FlagsPermissionCargo.config_interval_auto_refresh_cargo.getValue() * 1000);
  }
  stopInterval() {
    clearInterval(this.fetchInterval);
  }

  get cargoList() {
    return CargoController.retryCargo.data;
  }
  lastIdRetryCargo = 0;
  async fetchRetryCargoListWithoutLoading() {
    await CargoController.fetchCargoList({ type: "retry" });
  }
  async fetchCargoList(type: string) {
    this.isLoading = true;
    await CargoController.fetchCargoList({ type });
    this.isLoading = false;
  }
  async fetchLastIdRetryCargo() {
    const newLastIdRetryCargo = await CargoController.fetchLastIdCargoRetryCargo(
      "retry-cargo"
    );
    if (this.lastIdRetryCargo === 0 && newLastIdRetryCargo !== 0) {
      this.lastIdRetryCargo = newLastIdRetryCargo;
    }
    if (this.lastIdRetryCargo === 0 || newLastIdRetryCargo === 0) return;
    if (this.lastIdRetryCargo !== newLastIdRetryCargo) {
      this.lastIdRetryCargo = newLastIdRetryCargo;
      await this.fetchRetryCargoListWithoutLoading();
    }
  }

  deleteCargo() {
    CargoController.deleteCargo();
    this.handlerModalDeleteBooking(false, []);
  }

  // loading
  isLoading = false;

  // error cause
  get errorCause() {
    return CargoController.errorCause;
  }

  showModalDeleteBooking = false;
  handlerModalDeleteBooking(val: boolean, data?: any) {
    this.showModalDeleteBooking = val;
    this.tempDataReBooking = data;
  }

  showModalReBooking = false;
  tempDataReBooking: any = [];
  handlerModalReBooking(val: boolean, data?: any) {
    this.tempDataReBooking = data;
    this.showModalReBooking = val;
  }

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  formatValueNumber(number: number) {
    return formatByCountry(number, { type: "weight", country: this.countryCode });
  }

  get cargoFailedUnreadData() {
    return CargoController.cargoFailedUnreadData
  }

  get columns() {
    return [
      {
        name: "No. Booking",
        styleHead: "w-56 text-left whitespace-no-wrap break-all",
        render: (item: CargoData) => {
          return this.cargoFailedUnreadData?.newRcId?.length ? `<div class="w-full grid grid-cols-4 items-center break-all text-left">
            <div class="col-span-1">
              ${this.handleIconCargo(item.id)}
            </div>
            <div class="col-span-3">
              ${this.cargoColumnData(item.bookingRequestId, item.cargoNumber)}
            </div>
          </div>` : `<p class="w-full flex flex-row items-center gap-x-1 break-all text-left">
            ${this.cargoColumnData(item.bookingRequestId, item.cargoNumber)}
          </p>`;
        }
      },
      {
        name: "Kota asal - tujuan",
        styleHead: "w-36 text-left whitespace-no-wrap align-middle break-all",
        render: () => {
          return ``;
        },
        "custom-slot": true,
        slotName: "origin_destination"
      },
      {
        name: "Status kargo",
        styleHead: "w-26 text-left whitespace-no-wrap",
        render: (item: CargoData) => {
          return `<div class="overflow-ellipsis text-left">${this.setCargoStatus(item.cargoStatus)}</div>`;
        }
      },
      {
        name: "Alasan gagal",
        styleHead: "w-44 text-left whitespace-no-wrap",
        render: (item: CargoData) => {
          return `<div class="overflow-ellipsis text-left text-red-lp-100">${this.reasonColumnData(item, false)}</div>`;
        },
        hideIconTooltip: true,
        toolTip: (item: any) => {
            return `<div class='whitespace-normal w-48 font-montserrat text-black-lp-300 text-14px'>${this.reasonColumnData(item, true)}</div>`;
        },
      },
      {
        name: this.$t("Tanggal dibuat"),
        styleHead: "w-44 text-left whitespace-no-wrap align-middle",
        render: (item: CargoData) => {
          return `<div class="flex flex-col text-sm text-gray-lp-300"><div class="overflow-ellipsis text-left">${this.formatDateCargo(
            item.createdAt, "DD MMMM YYYY, HH:mm"
          )} WIB<div class="truncate text-gray-lp-600 w-32">${
            item.createdBy
          }</div>
            <div>${item.cargoHubName}</div>
          </div>`;
        }
      },
      {
        name: "Atur",
        styleHead: "w-40 text-left",
        render: () => {
          return ``;
        },
        "custom-slot": true,
        slotName: "atur_cancel_booking"
      }
    ];
  }

  destinationAirportCode(item: CargoData): string {
    return item.cargoType === "plane"
      ? `${item.airportDestinationCityCode} - ${item.airportDestinationCityName}`
      : "-";
  }

  originAirportCode(item: CargoData): string {
    return item.cargoType === "plane"
      ? `${item.airportOriginCityCode} - ${item.airportOriginCityName}`
      : "-";
  }

  setCargoStatus(cargoStatus: string) {
    switch (cargoStatus) {
      case 'failed':
        return "Gagal"
      default:
        return "Dibatalkan"
    }
  }

  handleDeleteCargoFromTable(item: CargoData) {
    CargoController.setCargoIdToCancelOrDelete(item.id);
    CargoController.setCargoNoForModal(item.cargoNumber);
    this.handlerModalDeleteBooking(true, item);
  }

  goToReBooking() {
    const bookingQueryObject = {
      autofill: true,
      rcId: this.tempDataReBooking.id
    };
    const bookingQuery = new QueryParamsEntities2(bookingQueryObject);
    router.push(`/cargo/create?${bookingQuery.queryString}`);
    ReadyToCargoController.setFlowBooking("rebooking")
    CargoController.setIsDeleteStt(false);
    this.handlerModalReBooking(false, []);
  }

  cargoColumnData(bookingRequestId: string, cargoNumber: string, isForUrl?: boolean) {
    const cargoNumberData = bookingRequestId ? bookingRequestId : cargoNumber
    if (isForUrl) {
      return cargoNumberData
    }
    return ellipsisString(cargoNumberData, 40)
  }

  cityColumnData(cityCode: string, cityName: string) {
    return cityCode && cityName ? `${cityCode} - ${cityName}` :  "-"
  }

  reasonColumnData(item: CargoData, isForTooltip: boolean) {
    const isReasonExist = item.reasonFailed ? item.reasonFailed : "Gagal mendapatkan response nGen";
    const reasonData = isReasonExist

    // https://lionparcel.atlassian.net/browse/CS-12922
    // if (item.isFromRtc && item.cargoType === "plane") {
    //   reasonData = !item.bookingRequestId ? "Gagal mendapatkan response nGen" : isReasonExist
    // }

    return !isForTooltip ? ellipsisString(reasonData, 50) : reasonData
  }

  vehiclePoliceNumberColumnData(number: string) {
    return number !== "-" ? number : "-"
  }

  cargoTypeColumnData(type: string) {
    return type ? capitalize(type) : "-"
  }

  roundedNumberColumnData(number: number) {
    return number ? number.toString() : "-"
  }

  decimalNumberColumnData(number: number | string) {
    const decimalNumber = Number(number);
    return decimalNumber !== 0 ? `${formatByCountry(decimalNumber, { type: "weight", country: this.countryCode })} Kg` : "-"
  }

  dateColumnData(date: string, isWithTime: boolean) {
    if (!date) {
      return "-"
    }
    return isWithTime ? formatDate(date) : formatDateWithoutTime(date)
  }

  async downloadEPL(id: number) {
    await CargoController.getDownloadData({ id: id, type: "epl" });
  }

  async downloadManifest(id: number) {
    await CargoController.getDownloadData({ id: id, type: "cargo" });
  }

  printAWBLionCargo(AWBNo: number) {
    NGenController.printAWBLionCargo({ AWBNo: AWBNo });
  }

  // Print
  check = null;
  refs: any = "";
  cargoNumber = "";

  chevronUp: boolean[] = [];

  get pagination() {
    return CargoController.retryCargo.pagination;
  }

  get cargoListAvailable() {
    return (
      !this.cargoList.length && !this.isLoading && this.pagination.page === 1
    );
  }

  // detail
  onClickRow(item: CargoData) {
    router.push(
      `/cargo/${encodeURIComponent(this.cargoColumnData(item.bookingRequestId, item.cargoNumber, true))}?rc_no=${item.id}`
    );
  }

  handleIconCargo(itemId: number) {
    if(this.cargoFailedUnreadData?.newRcId?.includes(itemId)) {
      return `
        <span class="px-2 py-1 rounded-full text-white bg-red-lp-1500 text-12px">Baru</span>
      `
    }

    return ""
  }

  handleArrivalDateTime(item: any) {
    const departure = item.departureDate;
    const arrival = item.arrivalDate;
    return `${
      !departure || !arrival
        ? "-"
        : `${this.formatDepartureArrival(departure, arrival)}
            </div>
            ${
              this.getDiffDay(departure, arrival) > 0
                ? `<div class="text-gray-lp-300 px-1 text-10px bg-gray-lp-200 font-medium rounded">+${this.getDiffDay(
                    departure,
                    arrival
                  )} ${this.$t("hari")}</div>
            </div>`
                : ""
            }`
    }`;
  }

  formatDepartureArrival(departureDate: string, arrivalDate: string) {
    return `${this.formatDateCargo(
      departureDate,
      "HH:mm"
    )} - ${this.formatDateCargo(arrivalDate, "HH:mm")}`;
  }

  getDiffDay(departureDate: any, arrivalDate: any, splitBy = "T") {
    if (!departureDate || !arrivalDate) return 0;
    else {
      return this.$moment(arrivalDate?.split(splitBy)[0])
        .utcOffset(arrivalDate)
        .diff(
          this.$moment(departureDate?.split(splitBy)[0]).utcOffset(
            departureDate
          ),
          "days"
        );
    }
  }

  formatDateCargo(
    date: any,
    format = "DD MMMM YYYY",
    isUtcOffset = true
  ): string {
    const offset = this.$moment(date).locale("id").utcOffset(date);
    const withoutOffset = this.$moment(date).locale("id");
    return isUtcOffset ? offset.format(format) : withoutOffset.format(format);
  }

  onHandleFilter() {
    this.fetchCargoList("retry");
  }
}
